import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  sectionIndent: {
    marginBottom: '42px',
  },
  inputIndent: {
    marginBottom: '24px',
    [theme.breakpoints.down('sm')]: {
      margin: '0px 20px 0px 20px',
      alignItems: 'center',
      textAlign: 'center',
      paddingBottom: '20px'
    },
  },
  addOnsItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: '15px',
    marginBottom: '15px',
    borderBottom: '1px solid #e2ebf6',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      // flexDirection: 'column',
      // justifyContent: 'center',
    },
  },
  photo: {
    width: '200px',
    height: '120px',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    borderRadius: '3px',
    margin: '0 20px 0 0',
    [theme.breakpoints.down('sm')]: {
      width: '150px',
      height: '100px',
      margin: '0 10px 0 0',
    },
    [theme.breakpoints.down('xs')]: {
      width: '120px',
      margin: '0 5px 0 5px',
  },
  },
  addOnsTitle: {
    fontWeight: 'bold',
    marginBottom: '8px',
    [theme.breakpoints.down('sm')]: {
     paddingLeft: '40px'
    },
  },
  addOnsInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  addOnsDescription: {
    width: '416px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      textAlign: 'center',
      padding: '20px 0'
    },
  },
  addOnsPrice: {
    fontSize: '13px',
    fontWeight: 'bold',
  },
  addOnsInput: {
    width: '170px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  currencyWrapper: {
    color: theme.palette.text.primary,
    fontWeight: 'bold',
    marginRight: '20px',
  },
  currency: {
    fontSize: '10px',
  },
  descriptionCurrency: {
    marginRight: '20px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  mobileDescriptionCurrency: {
    // display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      // margin: '0 0 0 0',
    },
  },
  titleCurrency: {
    display: 'none',
    marginLeft: '10px',
    minWidth: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  itemTitleWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  currencyInputWrapper: {
    display: 'flex',
    alignItems: 'baseline',
    minWidth: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

export default useStyles;
